module.exports = __webpack_public_path__ + "img/3-7-2.416d328a.png";